import { useEffect, useState, useContext } from 'react'
import { Dialog, DialogContent, DialogActions, Button } from '@material-ui/core'

import MultipleMultimedia from '../../QuestionForms/MultipleMedia/MultipleMultimedia'
import ShortAnswer from '../../QuestionForms/ShortAnswer/ShortAnswer'
import LongAnswer from '../../QuestionForms/LongAnswer/LongAnswer'

import { ExamContext } from 'containers/Examination/ExaminationContext'

const NewItemModal = ({modalState, onClose}) => {
  const examContenxt = useContext(ExamContext)
  const [open, setOpen] = useState(false)
  const [type, setType] = useState(null)

  const [addingQuestion, setAddingQuestion] = useState(false)

  const handleClose = () => {
    onClose()
  }

  const saveQuestion = async () => {
    setAddingQuestion(true)
    await examContenxt.saveQuestion()
    setAddingQuestion(false)
  }

  useEffect(() => {
    setOpen(false)
    if (modalState !== "closed") {
      setType(modalState)
      setOpen(true)
    }
  }, [modalState])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      disableBackdropClick={true}
    >
      <DialogContent>

        {type === "MULTIPLE_CHOICES" && <MultipleMultimedia onChange={(questionObject) => examContenxt.setQuestion(questionObject)} />}
        {type === "SHORT_ANSWER" && <ShortAnswer onChange={(questionObject) => examContenxt.setQuestion(questionObject)} />}
        {type === "LONG_ANSWER" && <LongAnswer onChange={(questionObject) => examContenxt.setQuestion(questionObject)} />}

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Discard
          </Button>
          <Button onClick={() => saveQuestion()} color="primary">
            {addingQuestion === true &&
              <div>
                <i className="fa fa-spinner fa-spin"></i> Adding your question...
              </div>
            }

            {addingQuestion !== true &&
              <div>
                Add Question
              </div>
            }
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

export default NewItemModal